module.exports = __webpack_public_path__ + "img/placard_m_01.a6bb260c.png";